/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

/**
 * @author Tyrus Malmstrom
 *
 * Module that encapsulates the toast notification library. Created as a module so it could be injected and mocked for
 * Testing.
*/

'use strict';

angular.module('bulbApp.iziToastModule', [])

.constant('IZITOAST', {
  defaultOptions: {
    theme: 'dark',
    timeout: 2000,
    close: false,
    icon: 'fas fa-inbox',
    position: 'center',
    progressBarColor: 'rgb(0,174,239)' // $bulb-blue-color
  }
})

/**
 * iziToast is a Elegant, responsive, flexible and lightweight notification plugin with no dependencies. It is
 * installed as window.iziToast.
 *
 * Define the normal default value of iziToast. This is overridden in the unit test, which mocks iziToast.
 */
.value('iziToast', window.iziToast)
.service('BulbToastService', ['IZITOAST', BulbToastService]);

function BulbToastService(IZITOAST) {

  /**
   * Function that displays the toast with the passed message:
   *
   * @param message {String} The message that the toast will display.
   */
  this.show = function(message) {
    IZITOAST.defaultOptions.message = message;
    iziToast.show(IZITOAST.defaultOptions); // jshint ignore:line
  };

}


